import { render, staticRenderFns } from "./FormSpecialSourceSelector.vue?vue&type=template&id=4fc4e5f4&scoped=true"
import script from "./FormSpecialSourceSelector.vue?vue&type=script&lang=js"
export * from "./FormSpecialSourceSelector.vue?vue&type=script&lang=js"
import style0 from "./FormSpecialSourceSelector.vue?vue&type=style&index=0&id=4fc4e5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4e5f4",
  null
  
)

export default component.exports